import Vue from 'vue';

export const NotificationService = new Vue({
  methods: {
    error(text) {
      this.message({ text, className: 'snackbar-error' });
    },

    success(text = 'Success operation') {
      this.message({ text, className: 'snackbar-success' });
    },

    warn(text = 'warn operation') {
      this.message({ text, className: 'snackbar-warn' });
    },

    message(params) {
      this.$emit('message', params);
    },
  },
});
